<form [formGroup]="editFormTitle" (ngSubmit)="submitForm()">
  <sn-form [form]="editFormTitle" [fields]="formFieldTitle" [model]="formModel"></sn-form>
</form>
